import { useRef, useState } from 'react';
import { cn } from '@/lib/utils';

const HOLD_MS = 900;

export function HoldButton({
  label,
  holdingLabel,
  onComplete,
  disabled,
  className,
}: {
  label: string;
  holdingLabel: string;
  onComplete: () => void;
  disabled?: boolean;
  className?: string;
}) {
  const [holding, setHolding] = useState(false);
  const timer = useRef<number | null>(null);

  const cancel = () => {
    if (timer.current != null) window.clearTimeout(timer.current);
    timer.current = null;
    setHolding(false);
  };

  const start = () => {
    if (disabled || timer.current != null) return;
    setHolding(true);
    timer.current = window.setTimeout(() => {
      timer.current = null;
      setHolding(false);
      onComplete();
    }, HOLD_MS);
  };

  return (
    <button
      type="button"
      className={cn('np-hold', holding && 'is-holding', className)}
      disabled={disabled}
      aria-describedby="np-hold-hint"
      onPointerDown={(event) => {
        if (event.button !== 0) return;
        event.currentTarget.setPointerCapture(event.pointerId);
        start();
      }}
      onPointerUp={cancel}
      onPointerCancel={cancel}
      onLostPointerCapture={cancel}
      onKeyDown={(event) => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        if (!event.repeat) start();
      }}
      onKeyUp={(event) => {
        if (event.key === ' ' || event.key === 'Enter') cancel();
      }}
      onBlur={cancel}
    >
      {holding ? holdingLabel : label}
    </button>
  );
}
